module.exports = __webpack_public_path__ + "static/media/dansketext-regular.daad3540.woff";